export const PAGE = {
    WIDTH: 612,
    HEIGHT: 792,
    MARGIN_LEFT: 36,
    MARGIN_RIGHT: 576,
    CONTENT_WIDTH: 540,
    TOP_MARGIN_DEFAULT: 36,
    PAGE_NUMBER_Y: 770,
    PAGE_NUMBER_X: 306
};

export const COLORS = {
    TEXT_MAIN: [0, 0, 0],
    TEXT_MUTED: [100, 100, 100],
    TEXT_LIGHT: [0, 0, 0],
    TEXT_DARK_GRAY: [30, 30, 30],
    TEXT_MEDIUM_GRAY: [50, 50, 50],
    TEXT_BODY_GRAY: [60, 60, 60],

    LINE_DARK: [0, 0, 0],
    LINE_MEDIUM: [34, 34, 34],
    LINE_LIGHT: [0, 0, 0],
    LINE_BORDER: [100, 100, 100],

    BG_BOX: [238, 240, 248],
    BG_HEADER: [240, 240, 240],
    BG_TERMS_CARD: [245, 249, 252],
    BORDER_TERMS_CARD: [200, 220, 225],
    BG_WHITE: [255, 255, 255]
};

export const DEFAULT_SPACING = {
    headerBottom: 53,
    infoBoxBottom: 28,
    productBlockGap: 14,
    summaryTopGap: 50,
    summaryBottomGap: 20,
    signatureBoxGap: 62,
    termsGap: 12,
    contactFooterGap: 10
};
